import { ClassAttributes, createElement, useContext } from 'react';

import { context as DependencyContext } from '../context/dependency';
import { context as HistoryContext } from '../context/history';
import { context as StateContext } from '../context/state';
import Screen from '../screen/FatalErrorScreen';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const FatalErrorScreen = ({ className }: Props) => {
  const dependency = useContext(DependencyContext);
  const history = useContext(HistoryContext);
  const state = useContext(StateContext);

  return state.fatalError ? (
    <Screen
      error={state.fatalError.error}
      solveTo={state.fatalError.solveTo}
      onClickBackButton={(_: any, solveTo: string) => {
        history.push(solveTo);
        dependency.errorPresenter.resolveFatal();
      }}
      className={className}
      pathname={state.location.pathname}
    />
  ) : null;
};

export default FatalErrorScreen;
